module.exports = new __parcel__URL__("squigglyLineDAS.79191e0b.svg").toString();